<template>
  <div>
    <b-input-group class="flex-nowrap">
      <b-button
        :id="'dropdown-trigger-' + _uid"
        :disabled="isDisabled"
        variant="outline-secondary"
        size="sm"
        class="flex-grow-1 flex-shrink-1 d-flex justify-content-between align-items-center bg-white text-dark border shadow-none"
        style="min-width: 100px"
      >
        <span class="text-truncate mr-2">
          {{ item ? item.name : 'Не выбрано' }}
        </span>
        <font-awesome-icon icon="chevron-down" size="xs" class="text-muted"/>
      </b-button>

      <b-popover
        :target="'dropdown-trigger-' + _uid"
        triggers="focus"
        tabindex="-1"
        placement="bottom"
        container="body"
        ref="popoverSearch"
      >
        <div class="py-2 px-3" @click.stop>
          <b-form-input
            size="sm"
            v-model="query"
            autocomplete="off"
            placeholder="Поиск..."
          />
          <div v-if="items.length === 0" class="text-muted text-small mt-1">
            Ничего не найдено
          </div>
        </div>

        <div class="scrollable-dropdown-content">
          <b-list-group flush @click.stop>
            <b-list-group-item
              v-for="option in items"
              :key="option.id"
              button
              action
              class="d-flex align-items-center justify-content-between py-2 px-1"
              @click="onClick(option)"
            >
              <div>
                 <span
                   class="d-inline-block rounded-circle mr-2"
                   :style="{ backgroundColor: option.color || '#ced4da', width: '10px', height: '10px', flexShrink: 0 }"
                 />
                <span>{{ option.name }}</span>
              </div>

              <font-awesome-icon v-if="item && item.id === option.id" icon="check"/>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-popover>

      <b-input-group-append class="flex-shrink-0">
        <b-button size="sm" :disabled="isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
          v-if="canCreateCatalog()"
          size="sm"
          variant="success"
          :disabled="isDisabled"
          @click="showModalCatalog"
          v-b-tooltip.hover.v-success
          title="Создать справочник"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <slot
      name="create-catalog"
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      :refresh="onCatalogCreated"
    />

  </div>
</template>

<script>
import catalogs from "../../network/catalogs";
import permissions, {PERM} from "../../utilites/permissions";

export default {
  name: "CatalogSelect",
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
    fetchData: {type: Function, required: true},
    searchData: {type: Function, required: true},
    isCreatable: { type: Boolean, default: true },
  },
  data() {
    return {
      query: "",
      items: [],
      item: null,
      isModalVisible: false,
    }
  },
  async mounted() {
    this.items = await this.getItems(this.query);
  },
  methods: {
    async configure(id) {
      this.query = "";

      if (id > 0) {
        const data = (await this.fetchData(id)).data;
        if (data != null) {
          this.item = data;
          return;
        }
      }

      this.items = await this.getItems(this.query);
    },
    onClear() {
      this.item = null;
      this.$emit('onSelect', null);
    },
    onClick(item) {
      this.item = item;
      this.$emit('onSelect', item);
      if (this.$refs.popoverSearch) {
        this.$refs.popoverSearch.$emit('close');
      }
    },
    async getItems(query) {
      const result = await this.searchData(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onCatalogCreated(newItem) {
      this.items.push(newItem);
      this.onClick(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_EDIT]) && this.isCreatable;
    },
  },
  watch: {
    'id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.configure(newId);
        }
      }, immediate: true
    },
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      }, deep: true
    },
  }
}
</script>

<style scoped>
.scrollable-dropdown-content {
  max-height: 200px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CatalogSelect.vue